import { apiRequest } from "./api-client";

export const authService = {
    register(payload) {
        return apiRequest("/auth/register", {
            method: "POST",
            body: payload
        });
    },
    login(payload) {
        return apiRequest("/auth/login", {
            method: "POST",
            body: payload
        });
    },
    logout() {
        return apiRequest("/auth/logout", {
            method: "POST"
        });
    },
    returnToAdmin() {
        return apiRequest("/auth/return-to-admin", {
            method: "POST"
        });
    },
    updateProfile(payload) {
        return apiRequest("/me/profile", {
            method: "PATCH",
            body: payload
        });
    },
    deleteProfile() {
        return apiRequest("/me/profile", {
            method: "DELETE"
        });
    },
    uploadAvatar(file) {
        const formData = new FormData();
        formData.set("file", file);
        return apiRequest("/me/avatar", {
            method: "POST",
            body: formData
        });
    },
    changePassword(payload) {
        return apiRequest("/auth/change-password", {
            method: "POST",
            body: payload
        });
    },
    me() {
        return apiRequest("/auth/me");
    }
};
